import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";import { LayoutMinWidth } from "../common-styles";

const headerStyle = (theme: Theme) => createStyles({

    toolbar: {
        // Sobrepoe valor padr�o da toolbar.
        paddingLeft: 0,
        paddingRight: 0,
        minHeight: 78
    },

    appBar: {
        boxShadow: "none",
        borderBottom: "0",
        marginBottom: "0",
        width: "100%",
        color: "#555555",
        border: "0",
        paddingTop: "5px",
        paddingBottom: "5px",
        display: "block",
        // Importante: isto � necess�rio para o componente MUI-APPBAR n�o desloque o conte�do para a esquerda quando a tela estiver abaixo de minWidth.
        left: 0,
        top: 0,
        minWidth: LayoutMinWidth,
        zIndex: theme.zIndex.drawer + 1
    },

    flex: {
        flex: 1
    },


    headerColor: {
        backgroundColor: theme.palette.primary.dark,
        color: "#FFFFFF",
    },

    logo: {
        position: "relative",
        paddingLeft: 8,
        paddingRight: 8,
        "& a:focus": {
            outline: "none"
        }
    },

    logoText: {
        paddingTop: "4px",
        paddingBottom: "4px",
        textAlign: "center",
        lineHeight: "initial",
        fontSize: theme.typography.h5.fontSize
    },

    img: {
        maxWidth: "128px",
        maxHeight: "64px",
        border: "0"
    },
});

export default headerStyle;
